<template>
  <div class="box">
    <Banner :banner-h="$t('displayCase.bannerTitle')" :text-style="textStyle" :text-content-style="textContentStyle"
            :banner-title-style="bannerTitleSytle" :banner-p="$t('displayCase.bannerDescription')"
            :banner-img="bannerImg1"></Banner>

    <scroll-animate>
      <div class="productOverviewOfThe">
        <h1></h1>
        <p></p>
      </div>
    </scroll-animate>

    <scroll-animate>
      <div class="productCatg">
        <!--      <h1>产品类别</h1>-->

        <div class="catgDetails" v-for="(item,index) in catgDetails" :key="index">
          <h2>{{ item.categoryName }}</h2>
          <div class="catgItem" v-for="(item,index) in item.catgItem" :key="index" @click="ruterClick(item)">
            <div class="catgImg">
              <img :src="item.catgImg"/>
            </div>
            <div class="catgItemText">
              <span>{{ item.name }}</span>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>

      </div>
    </scroll-animate>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import {displayCase} from "@/assets/js/displayCase.js";
import "@/assets/css/product-pub.scss"
import i18n from '@/plugins/i18n';
import ScrollAnimate from "../../components/ScrollAnimate.vue";

export default {
  name: "displayCase",
  components: {
    ScrollAnimate,
    Banner
  },
  data() {
    return {
      bannerImg1: require("@/assets/img/banner-bg/bananer-mountain.png"),
      textStyle: {
        width: "70%",
      },
      textContentStyle: {
        marginLeft: "0"
      },
      bannerTitleSytle: {
        fontSize: "2rem",
      },
      catgDetails: []
    }
  },

  methods: {
    ruterClick(item) {
      this.$router.push({
        name: 'productInfoShow',
        query: {
          item: item.id
        }
      })
    }
  },
  mounted() {
    this.catgDetails = displayCase
  },
}
</script>


<style scoped>

</style>
